module.exports = __webpack_public_path__ + "media/login.b7da6872.mp4";